import {
  HOURS_MS, MINUTES_MS, SECONDS_MS,
} from '../constants/time';

/**
 * Returns the milliseconds since the start of the day
 */
export function getMillisecondsSinceStartOfDay(date?: Date): number | undefined {
  if (date === undefined) {
    return undefined;
  }
  return (date.getHours() * HOURS_MS) + (date.getMinutes() * MINUTES_MS) + (date.getSeconds() * SECONDS_MS) + date.getMilliseconds();
}

/**
 * Compares two dates by their UTC date part only (ignores time).
 * Returns -1 if d1 is before d2, 1 if d1 is after d2, 0 if equal.
 */
export function compareDatesUTC(d1: Date, d2: Date): -1 | 0 | 1 {
  const dateString1: string = d1.toISOString().split('T')[0];
  const dateString2: string = d2.toISOString().split('T')[0];

  if (dateString1 < dateString2) {
    return -1;
  }
  if (dateString1 > dateString2) {
    return 1;
  }
  return 0;
}
